import { render, staticRenderFns } from "./ModalCompensationHistory.vue?vue&type=template&id=d9a49022"
import script from "./ModalCompensationHistory.vue?vue&type=script&lang=ts"
export * from "./ModalCompensationHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports